import React, { useState } from 'react';
import { Link, useHistory } from "react-router-dom";

const ImageButton = ({ defaultImage, hoverImage, text, redirectUrl }) => {

    const history = useHistory();

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <button
      onClick={()=>history.push(redirectUrl)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ border: 'none', background: 'none', cursor: 'pointer' }}
      className = "hover-button-blogs"
    >
        <p style={{marginBottom: 0}}>{text}</p>
      <img
        src={isHovered ? hoverImage : defaultImage}
        alt="Button Image"
        style={{ width: '100px', height: '100px' }}
      />
    </button>
  );
};

export default ImageButton;